export const TEXT_FIELD_NAME = 'text';
export const EMAIL_FIELD_NAME = 'email';
export const PHONE_FIELD_NAME = 'tel';
export const DATE_FIELD_NAME = 'date';
export const DATE_TIME_FIELD_NAME = 'datetime-local';
export const TIME_FIELD_NAME = 'time';

export const INTERNAL_FORM_FIELD_TYPES = {
  MarkdownText: 'MarkdownText',
  MultipleChoice: 'MultipleChoice',
  SingleChoice: 'SingleChoice',
  ShortText: 'ShortText',
  LongText: 'LongText',
  Email: 'Email',
  PhoneNumber: 'PhoneNumber',
  FileUpload: 'FileUpload',
  LocationSelect: 'LocationSelect',
  Name: 'Name',
  Date: 'Date',
  DateTime: 'DateTime',
  Time: 'Time',
};

export const RECIPE_FORM_FIELD_TYPES = {
  MarkdownText: 'markdownText',
  MultipleChoice: 'multiSelect',
  SingleChoice: 'select',
  ShortText: TEXT_FIELD_NAME,
  LongText: 'textarea',
  Email: EMAIL_FIELD_NAME,
  PhoneNumber: PHONE_FIELD_NAME,
  FileUpload: 'fileUpload',
  LocationSelect: 'locationSelect',
  Date: DATE_FIELD_NAME,
  DateTime: DATE_TIME_FIELD_NAME,
  Time: TIME_FIELD_NAME,
};

export const FIELD_TYPE_TO_WIDGET = {
  [RECIPE_FORM_FIELD_TYPES.ShortText]: 'input',
  [RECIPE_FORM_FIELD_TYPES.Email]: 'input',
  [RECIPE_FORM_FIELD_TYPES.PhoneNumber]: 'input',
  [RECIPE_FORM_FIELD_TYPES.Date]: 'input',
  [RECIPE_FORM_FIELD_TYPES.DateTime]: 'input',
  [RECIPE_FORM_FIELD_TYPES.Time]: 'input',
};

export const FIELD_TYPE_TO_INPUT_TYPE = {
  [RECIPE_FORM_FIELD_TYPES.ShortText]: TEXT_FIELD_NAME,
  [RECIPE_FORM_FIELD_TYPES.Email]: EMAIL_FIELD_NAME,
  [RECIPE_FORM_FIELD_TYPES.PhoneNumber]: PHONE_FIELD_NAME,
  [RECIPE_FORM_FIELD_TYPES.Date]: DATE_FIELD_NAME,
  [RECIPE_FORM_FIELD_TYPES.DateTime]: DATE_TIME_FIELD_NAME,
  [RECIPE_FORM_FIELD_TYPES.Time]: TIME_FIELD_NAME,
};

export const INPUT_TYPE_TO_RECIPE_FIELD_TYPE = {
  [TEXT_FIELD_NAME]: RECIPE_FORM_FIELD_TYPES.ShortText,
  [EMAIL_FIELD_NAME]: RECIPE_FORM_FIELD_TYPES.Email,
  [PHONE_FIELD_NAME]: RECIPE_FORM_FIELD_TYPES.PhoneNumber,
  [DATE_FIELD_NAME]: RECIPE_FORM_FIELD_TYPES.Date,
  [DATE_TIME_FIELD_NAME]: RECIPE_FORM_FIELD_TYPES.DateTime,
  [TIME_FIELD_NAME]: RECIPE_FORM_FIELD_TYPES.Time,
};
